import script from "./AuthDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AuthDialog.vue?vue&type=style&index=0&id=7dce6636&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dce6636"]])

export default __exports__